// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Index__pc_only___1afmR","sp_only":"Index__sp_only___2Mc1N","container":"Index__container___2Z9sJ"};